<template>
  <v-select
    ref="select"
    :label="label"
    :items="countryItems"
    item-text="name"
    :item-value="countryValue"
    return-object
    v-model="selectedCountry"
    v-bind:value="value"
    v-on:input="onInputChanged"
    persistent-hint
    :hint="hintText"
    :class="{ 'mb-3': hasOtherCountries }"
  >
  </v-select>
</template>

<script>
export default {
  props: {
    value: Object,
    label: String,
    multipleCountriesLabel: String,
    countries: Array,
    countryValue: { type: String, default: 'id' },
    otherCountries: {
      type: Array,
      default() {
        return [];
      },
    },
    required: Boolean,
  },

  data() {
    return {
      countryItems: [],
      selectedCountry: null,
    };
  },

  watch: {
    value: {
      handler: function (newValue) {
        this.selectedCountry = newValue;
      },
      immediate: true,
    },
    countries: {
      handler: function (newList) {
        if (!newList) return;
        const sweden = newList.find((country) => country.cca3 === 'SWE');
        const nordicCountries = newList.filter((country) => country.isNordic && country.cca3 !== 'SWE');
        const restOfTheWorld = newList.filter((country) => !country.isNordic);
        this.countryItems = [sweden, ...nordicCountries, { id: -1, name: '', divider: true }, ...restOfTheWorld];
      },
      immediate: true,
    },
  },

  // För att kunna använda denna komponent i en form och validera den
  inject: {
    form: { default: null },
  },
  created() {
    this.form && this.form.register(this);
  },
  beforeDestroy() {
    this.form && this.form.unregister(this);
  },

  computed: {
    hasOtherCountries() {
      return this.otherCountries && this.otherCountries.length > 0;
    },
    hintText() {
      if (!this.hasOtherCountries) return null;

      const otherCountryNames = this.otherCountries.map((country) => country.name).join(', ');
      return `${multipleCountriesLabel}: ${otherCountryNames}`;
    },
    hasError() {
      return this.required && !this.selectedCountry;
    },
  },

  methods: {
    onInputChanged() {
      this.$emit('input', this.selectedCountry);
      const allCountries = [this.selectedCountry, ...(this.otherCountries || [])];
      this.$emit('onCountrySelected', allCountries);
    },

    // Used by the form to reset validation on the field
    resetValidation() {
      this.$refs.select.resetValidation();
    },
    reset() {
      this.$refs.select.reset();
    },
  },
};
</script>
